import SvgIcon from '@mui/material/SvgIcon';
import type { SxProps } from "@mui/material";
import React from "react";

export const GroupOfPeople3: React.FC<{ sx?: SxProps }> = ({ sx }) => {
    return (
        <SvgIcon sx={sx}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 95.387 64.678"
            >
                <g>
                    <path
                        d="M423,176a10.965,10.965,0,1,1-10.965-10.965A10.965,10.965,0,0,1,423,176"
                        transform="translate(-364.342 -149.922)"
                        fill="#e85317"
                    />
                    <path
                        d="M354.34,444.395H354.3c-.606-6.474-7.387-11.576-15.662-11.576s-15.056,5.1-15.662,11.576h-.044L320.3,456.337a1.254,1.254,0,0,0,1.225,1.524h34.219a1.254,1.254,0,0,0,1.225-1.524Z"
                        transform="translate(-290.94 -393.183)"
                        fill="#e85317"
                    />
                    <path
                        d="M743.269,10.964A10.965,10.965,0,1,1,732.3,0a10.965,10.965,0,0,1,10.965,10.965"
                        transform="translate(-655.281 0.001)"
                        fill="#e85317"
                    />
                    <path
                        d="M692.736,292.819H665.315a1.382,1.382,0,0,1-1.323-1,14.4,14.4,0,0,0-4.548-6.829,1.407,1.407,0,0,1-.463-1.37l.939-4.27h.045c.606-6.473,7.386-11.576,15.662-11.576s15.057,5.1,15.662,11.576h.045l2.628,11.942a1.254,1.254,0,0,1-1.225,1.524"
                        transform="translate(-598.603 -243.255)"
                        fill="#e85317"
                    />
                    <path
                        d="M102.733,10.964A10.965,10.965,0,1,1,91.768,0a10.965,10.965,0,0,1,10.965,10.965"
                        transform="translate(-73.403 0.001)"
                        fill="#e85317"
                    />
                    <path
                        d="M34.548,284.993A14.4,14.4,0,0,0,30,291.823a1.382,1.382,0,0,1-1.323,1H1.255A1.254,1.254,0,0,1,.03,291.3l2.628-11.942H2.7c.605-6.473,7.387-11.576,15.662-11.576s15.056,5.1,15.662,11.576h.045l.939,4.269a1.407,1.407,0,0,1-.462,1.37"
                        transform="translate(0 -243.256)"
                        fill="#e85317"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};